import { gql, useQuery } from "@apollo/client";
import {
  MessageBar,
  Shimmer,
  ShimmerElementsGroup,
  ShimmerElementType,
} from "@fluentui/react";
import React, { useContext } from "react";
import AppContext, { IFilters } from "../../../AppContext";
import Title from "../../../components/Title";
import "./style.scss";
import { useTranslation } from "react-i18next";
import chainLists from "./chainLists";

export const titleEn = "Coverage";
export const title = "Cobertura";
export const filters: IFilters = {
  limitedPeriodo: false,
  showMedidas: false,
  hasTicketMedio: false,
  isDesglose: false,
  showEntorno: false,
  showSegmentos: false,
  showMyData: false,
};

const Graph = () => {
  const { semanas } = useContext(AppContext);
  const { t } = useTranslation();

  const GET_GRAPH = gql`
    query ($yr1: Int!, $wk1: Int!, $yr2: Int!, $wk2: Int!) {
      graph(
        Graph: "Posicion global"
        WeekRange: {
          Start: { Year: $yr1, Week: $wk1 }
          End: { Year: $yr2, Week: $wk2 }
        }
      )
    }
  `;

  const qry = useQuery(GET_GRAPH, {
    fetchPolicy: "no-cache",
    variables: {
      yr1: semanas[0].year,
      wk1: semanas[0].week,
      yr2: semanas[1].year,
      wk2: semanas[1].week,
    },
  });

  let errorMsg = t('An-error-has-occur-when-recovering-data');
  let loading = qry.loading || qry.data === undefined;
  let error = !semanas || !!qry.error;
  let emptyData = {
    Eventos: [""],
    Comentarios: [""],
    Grupo: false,
    Cadenas: [""],
    Error: false,
  };
  let data = emptyData;

  if (!!qry?.data) {
    try {
      data = qry?.data?.graph;
      if (!data) throw new Error(errorMsg);
      if (data?.Error) throw new Error(`${data.Error}`);
    } catch (err: any) {
      error = true;
      errorMsg = err.message ?? errorMsg;
    }
  }

  const counterShimmer = (
    <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
      <ShimmerElementsGroup
        flexWrap
        width={"100%"}
        shimmerElements={[
          {
            type: ShimmerElementType.line,
            width: 90,
            height: 17,
            verticalAlign: "top",
          },
          {
            type: ShimmerElementType.gap,
            width: "calc(100% - 90px)",
            height: 32,
          },
          {
            type: ShimmerElementType.line,
            width: "100%",
            height: 28,
            verticalAlign: "top",
          },
          { type: ShimmerElementType.gap, width: "100%", height: 32 },
          {
            type: ShimmerElementType.line,
            width: 90,
            height: 17,
            verticalAlign: "top",
          },
          {
            type: ShimmerElementType.gap,
            width: "calc(100% - 90px)",
            height: 32,
          },
          {
            type: ShimmerElementType.line,
            width: "100%",
            height: 28,
            verticalAlign: "top",
          },
        ]}
      />
    </div>
  );

  // Detectar país por hostname
  const host = window.location.hostname;
  const country = host.includes("pt") ? "PT" : "ES";

  return (
    <>
      <Title title={t('Coverage')} />
      {error && <MessageBar isMultiline={true}>{errorMsg}</MessageBar>}
      {!error && (
        <div className="global-container">
          {!loading && (
            <div className="cadenas-container">
              <div className="notification">
                {/* QSR Market */}
                <label>{t('Market')}</label>
                <ul>
                  {chainLists[country].QSR.map((cad, i) => (
                    <li key={i}>{cad}</li>
                  ))}
                </ul>
                {/* Segmentos solo en España */}
                {country === "ES" && (
                  <>
                    <label>{t('Casual-dining-segment')}</label>
                    <ul>
                      {chainLists.ES.CASUAL.map((cad, i) => (
                        <li key={i}>{cad}</li>
                      ))}
                    </ul>
                    <label>{t('Coffee-segment')}</label>
                    <ul>
                      {chainLists.ES.CAFE.map((cad, i) => (
                        <li key={i}>{cad}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            </div>
          )}
          {loading && (
            <Shimmer customElementsGroup={counterShimmer} width="400px" />
          )}
        </div>
      )}
    </>
  );
};

export default Graph;